<template>
    <div class="bizcomp-fund-market white">
        <div class="fund-market">
            <div class="fund-title">
                <div style="display: flex; align-items: center">
                    <img :src="require('../../assets/img/fundList-icon.png')" class="fund-ic" />
                    <span style="font-size: 28px; color: #333333">所以产品</span>
                </div>
                <div class="fund-search">
                    <el-autocomplete
                        v-model="searchText"
                        popper-class="my-autocomplete"
                        placeholder="请输入产品代码、名称"
                        class="input-search"
                        size="small"
                        :fetch-suggestions="querySearchAsync"
                        v-on:select="handleSelect"
                    >
                        <template slot-scope="{ item }">
                            <div class="name">
                                {{ item.value }}
                            </div>
                        </template>
                        <el-button
                            slot="suffix"
                            icon="el-icon-search"
                            class="search-icon"
                            type="text"
                            size="small"
                            v-on:click="searchFund"
                        />
                    </el-autocomplete>
                </div>
            </div>
            <div style="height: 10px"></div>
            <fund-list
                :has-load="hasLoad"
                :fund-info="fund"
                :tab-index="activeType"
                :all-page="allPage"
                v-on:new-fund="newFund"
            />
        </div>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import fundList from "@/components/financialmanagement/fundList";
import fundApi from "@/api/fund";

export default {
    name: "FundMarket",
    components: {
        fundList
    },
    mixins: [mixin],
    data() {
        return {
            ismatch: "0", // 是否只看风险匹配
            searchText: "", // 搜索文本内容
            fund: [], // 基金信息
            queryFind: null, // 定时器
            allPage: "0", // 所有数据条数
            pagecount: 10, // 分页条数
            pageoffset: 1, // 起始页
            activeType: "", // 基金类型
            hasLoad: false, // 是否已经查询数据
            sdxFundInfo: {},
            sdxDialogVisible: false,
            fundTypes: [],
            fundclass: "" // 公私募标记
        };
    },
    watch: {
        searchText(val, from) {
            if (from.length > 0 && val == "") {
                this.searchFund();
            }
        }
    },
    async created() {
        this.$store.commit("updateLoadFund", false);
        const info = this.$cache.getUser();
        if (info.professionflag == "0") {
            this.ismatch = info.ismatch || "1";
        }
        this.riskList = this.$cache.getDict("110143");
        this.fundclass = this.$util.getFundClass();
        this.doAction();
        this.fundTypes =
            this.fundclass == "1"
                ? JSON.parse(JSON.stringify(this.$util.getConfig().privateFundTypes))
                : JSON.parse(JSON.stringify(this.$util.getConfig().fundTypes));
        this.activeType = this.fundclass == "1" ? "999" : "hot";
        this.fundTypes.forEach((item) => {
            if (!item.val) {
                item.val = "999";
            }
        });
    },
    mounted() {},
    methods: {
        // 搜索基金
        searchFund() {
            this.pageoffset = 1;
            this.doAction(this.searchText);
        },
        // 获取下拉列表数据
        querySearchAsync(queryString, cb) {
            this.pageoffset = 1;
            let _cbArr = [];
            this.doAction(queryString, (res) => {
                // res.forEach((item, index) => {
                //     let _x = {};
                //     _x.value = item.fundname + "(" + item.fundcode + ")";
                //     _x.id = item.fundcode;
                //     _x.index = index;
                //     _cbArr.push(_x);
                // });
            });
            cb(_cbArr);
        },
        // 选中建议项
        handleSelect() {
            if (this.searchText.indexOf("(") != -1) {
                this.searchText = this.searchText.slice(0, this.searchText.indexOf("("));
            }
            this.pageoffset = 1;
            this.doAction();
        },
        // 获取新一页数据
        newFund(val) {
            this.pageoffset = val;
            this.doAction();
        },
        // 获取基金信息
        async getFund(val, cb) {
            const _this = this;
            const exType = ["999", "0", "zghr", "hot"];
            const _x = {
                tagids: this.activeType === "hot" ? "47223" : "",
                fundshowtype: exType.includes(this.activeType) ? "" : this.activeType,
                ismatch: this.ismatch,
                valuagrbuystate: "",
                keyword: val || (this.searchText ? this.searchText : ""),
                pagesize: cb ? 20 : this.pagecount,
                pagenum: val ? 1 : this.pageoffset,
                tradingmethod: this.$util.getConfig().systemtype,
                orderfield: "thisyear1ud",
                isasc: 0,
                mrfflag: this.activeType === "zghr" ? "1" : undefined,
                fundclass: this.fundclass
            };
            const res = await fundApi.getFundLists(_x);
            this.hasLoad = true;
            if (res.data) {
                this.$store.commit("updateLoadFund", true);
                if (this.pageoffset == 1) {
                    this.allPage = "0";
                }
                _this.fund = res.data.list;
                if (this.activeType === "hot" && !_this.fund.length) {
                    _this.activeType = "999";
                    _this.fundTypes.shift();
                    _this.doAction();
                }

                _this.allPage = res.data.total.toString();
                if (cb) {
                    cb.call(_this, res.data.list);
                }
            }
        },
        // 对基金频繁查询请求做处理
        doAction(val, cb) {
            const _this = this;
            if (cb) {
                val = this.$util.filterCode(val);
                this.searchText = val;
                if (val.length < 1) {
                    cb.call(this, []);
                    return false;
                }
            }
            clearTimeout(this.queryFind);
            this.queryFind = setTimeout(function () {
                _this.getFund(val, cb);
            }, 500);
        }
    }
};
</script>

<style lang="scss" scope>
@import "../../assets/css/varibles";
.white {
    background: #ffffff;
    border: 1px solid #f1f1f1;
    margin-bottom: 20px;
    padding-bottom: 20px;
}
.fund-title {
    display: flex;
    padding: 20px 0;
    align-items: center;
    justify-content: space-between;
    .fund-ic {
        width: 30px;
        height: 30px;
        margin-right: 12px;
    }
    .fund-search {
        .input-search {
            width: 400px;
            vertical-align: middle;
            .search-icon {
                margin: 0 5px;
                height: 40px;
                color: #666666;
            }
            .el-input__inner {
                height: 40px;
                line-height: 40px;
                border-bottom-right-radius: 0;
                border-top-right-radius: 0;
            }
            .el-input-group__append {
                background-color: var(--color-primary);
                color: $text-color6;
                font-size: $f20;
                border-color: var(--color-primary);
                padding: 0 10px;
            }
        }
        .fund-total {
            margin-left: 30px;
            margin-right: 15px;
            font-size: 18px;
            line-height: 40px;
            font-weight: normal;
            color: var(--color-primary);
        }
    }
}

.bizcomp-fund-market .risk-filter-text {
    border: none;
    margin: 0;
}
</style>
